import { render, staticRenderFns } from "./CourseSignUpFinish.vue?vue&type=template&id=3b1a5ff4&scoped=true"
import script from "./CourseSignUpFinish.vue?vue&type=script&lang=ts"
export * from "./CourseSignUpFinish.vue?vue&type=script&lang=ts"
import style0 from "./CourseSignUpFinish.vue?vue&type=style&index=0&id=3b1a5ff4&prod&scoped=true&lang=css"
import style1 from "./CourseSignUpFinish.vue?vue&type=style&index=1&id=3b1a5ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a5ff4",
  null
  
)

export default component.exports